import React from "react";

class CirclePercentage extends React.Component{
    constructor(props) {
        super(props);
    }
    render(){
        return(
            <div className="single-chart">
                <svg viewBox="0 0 36 36" className={"circular-chart "+this.props.className}>
                    <path className="circle-bg"
                          d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
                    />
                    <path className="circle"
                          stroke-dasharray={this.props.percent +', 100'}
                          d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
                    />
                    <text x="18" y="20.35" className="percentage">{this.props.text}</text>
                    <text x="18" y="23.35" className="percentage2">{this.props.text2}</text>
                    <text x="18" y="26.35" className="percentage3">{this.props.text3}</text>
                </svg>
            </div>
        );
    }
}

export default CirclePercentage;